module.exports = __webpack_public_path__ + "static/marchi-semplici-a9619c8af998be7399738c84bda8f59f.jpg";